import _ from 'underscore';
import platformUtilities from '../../modules/platform_utilities.js';
import WaterfallHelper from '../../modules/waterfall_helper.js';

// Wires the creative's demand tags table to the object stats panel: the panel owns the
// date range and the report, this fills the report columns in each row and lets the
// server sort on a report metric.  No markup of its own (no add button or bulk actions).
angular.module('vastdesk')
.component('creativeDemandTags', {
  bindings: {
    tableId: '@',
    sectionId: '@',
    currencyPlaceholder: '@',
    forecast: '<'
  },
  controllerAs: '$creativeDemandTagsCtrl',
  controller: ['$rootScope', function($rootScope) {

    var self = this;
    var serverSideTable;
    var serverSideDataTable;
    var reportData = [];
    var waterfallHelper = new WaterfallHelper();

    // scoped to this table's wrapper since the line items tab has its own #date_range
    var dateRangeSelector = function() {
      return serverSideTable.parents('.dataTables_wrapper').find('#date_range');
    };

    var reportRowFor = function(tableRow) {
      return _.findWhere(reportData, {demand_tag_id: tableRow.DT_RowAttr['data-demand-tag-id']}) || {};
    };

    var attachReportData = function(rows) {
      _.each(rows, function(r) {
        waterfallHelper.addReportDataToRow(r, reportRowFor(r), {currencyPlaceholder: self.currencyPlaceholder});
      });
    };

    var redrawTable = function() {
      waterfallHelper.drawServerSideTable(serverSideDataTable, false);
    };

    this.$onInit = function() {
      serverSideTable = $('#' + self.tableId);

      serverSideTable.on('init.dt', function() {
        serverSideDataTable = $(this).DataTable();
        waterfallHelper.addDateRangeSelect({section: '#' + self.sectionId, forecast: self.forecast});

        if (Array.isArray(reportData) && reportData.length > 0) {
          setTimeout(redrawTable, 0);
        }
      });

      serverSideTable.on('preXhr.dt', function(e, settings, data) {
        waterfallHelper.abortPendingAjaxRequests(serverSideTable, serverSideDataTable);

        data.date_range = dateRangeSelector().val();
        data.report_data = waterfallHelper.getDemandTagReportDataForDraw(serverSideTable, serverSideDataTable, reportData);
      });

      serverSideTable.on('xhr.dt', function(e, settings, json) {
        if (json && json.data) {
          attachReportData(json.data);
        }
      });
    };

    $rootScope.$on('updatingReportData', function(e, args) {
      if (args.table === self.tableId) {
        platformUtilities.triggerDataTablesProcessing(serverSideTable, true);
      }
    });

    $rootScope.$on('updatedReportData', function(e, args) {
      if (args.table === self.tableId) {
        reportData = args.resp.demand_tag_report;
        self.currencyPlaceholder = args.resp.currency_placeholder;
        redrawTable();
      }
    });

  }]
});
